var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container",style:({ display: 'block' })},[_c('div',{staticClass:"loading-loader"}),_c('div',{staticClass:"loading-content"},[_c('p',[_vm._v(" "+_vm._s(_vm.label)+" "),_c('br'),_c('small',[_vm._v(" "+_vm._s(_vm.description)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }